<template>
  <div class="kpt-remote-stream-root kpt-single-page">
    <vue-headful title="Remote Metric Stream" />
    <header class="kpt-single-header">
      <h4>Metric Stream</h4>
      <div class="page-control">
        <p>{{connectionMessage}}</p>
        <span>
          <font-awesome-icon :icon="['fas', 'circle']" class="has-text-success" v-if="connectionEstablished" title="Connected" />
          <font-awesome-icon :icon="['fas', 'circle']" class="has-text-danger" v-else title="Error connecting" />
        </span>
        <p>Last Updated {{format(lastUpdate, 'HH:mm:ss')}}</p>
      </div>
    </header>
    <b-tabs v-model="activeTab">
      <b-tab-item label="Remotes">
        <b-table :data="remoteMetrics">
          <b-table-column field="remoteId" label="Remote ID" width="300" v-slot="props">
            {{ props.row.remoteId }}
          </b-table-column>
          <b-table-column field="metrics" label="Metrics" v-slot="props">
            <pre>{{ props.row.metrics }}</pre>
          </b-table-column>
          <template slot="empty">
            <p>Waiting for remote metrics...</p>
          </template>
        </b-table>
      </b-tab-item>

      <b-tab-item label="Devices">
        <b-table :columns="[{ field: 'remoteId', label: 'Device Serial', width: 300 }, { field: 'metrics', label: 'Metrics' }]" :data="deviceMetrics">
          <template slot="empty">
            <p>Waiting for device metrics...</p>
          </template>
        </b-table>
      </b-tab-item>
    </b-tabs>
  </div>
</template>
<script>
import * as signalR from '@microsoft/signalr';
import { format } from 'date-fns';

export default {
  data() {
    return {
      activeTab: 0,
      lastUpdate: new Date(),
      streamConnection: null,
      streamMessages: [],
      guidRegex: new RegExp(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/),
      connectionEstablished: false,
      connectionMessage: '',
      format
    }
  },
  created() {
    this.streamConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.appConfig.liveUrl}/metrics?access_token=${window.$auth.accessToken}`)
      .withAutomaticReconnect()
      .build();

    this.streamConnection.on('ReceiveMetrics', (metrics) => {
      metrics.forEach(m => {
        // find existing metric to see if we need to merge or add
        const existingMetricById = this.streamMessages.findIndex(e => e.remoteId == m.remoteId);
        // if found, merge
        if (existingMetricById != -1) {
          this.streamMessages[existingMetricById] = m;
        } else { // otherwise add
          this.streamMessages.push(m);
        }
      })
      this.lastUpdate = new Date();
    });
    const self = this;
    this.streamConnection.start({ withCredentials: false }).then(() => {
      self.connectionMessage = 'Successfully started hub connection.';
      self.connectionEstablished = true;
    }).catch((err) => {
      self.connectionMessage = `Error establishing connection: ${err.statusCode}`;
      self.connectionEstablished = false;
    });
  },
  computed: {
    appConfig() {
      return this.$store.state.appConfig;
    },
    remoteMetrics() {
      return this.streamMessages.filter(m => m.remoteId.includes('-'));
    },
    deviceMetrics() {
      return this.streamMessages.filter(m => !this.isGuid(m.remoteId));
    }
  },
  methods: {
    isGuid(value) {
      return this.guidRegex.test(value);
    }
  },
  destroyed() {
    this.streamConnection.stop();
    this.streamConnection.off('ReceiveMetrics');
  }
}
</script>
<style lang="scss" scoped>
.kpt-remote-stream-root {
  position: relative;
  height: 100%;
  overflow-y: auto;
}
</style>
